import React from "react";

const {
  Provider: JsonServiceProvider,
  Consumer: JsonServiceConsumer,
} = React.createContext();

export { JsonServiceProvider, JsonServiceConsumer };
